import { useEffect, useState } from "react";
import { api, ApiError, type VeiculoManutencao } from "../api";
import { IconClose } from "../icons";

/**
 * Aviso DIRECIONADO ao responsável (integração com o Usuário): quando o
 * colaborador vinculado ao login atual tem veículo(s) precisando de manutenção
 * (vencida / próxima / em manutenção), mostra uma faixa no topo do módulo.
 * Admins e logins sem colaborador vinculado não recebem o aviso pessoal —
 * para gestão existe o card no Dashboard.
 */
export default function ManutencaoAviso({ colaboradorId }: { colaboradorId: number | null }) {
  const [veiculos, setVeiculos] = useState<VeiculoManutencao[]>([]);
  const [dispensado, setDispensado] = useState(false);

  useEffect(() => {
    if (colaboradorId == null) {
      setVeiculos([]);
      return;
    }
    let alive = true;
    setDispensado(false);
    api
      .manutencaoVeiculos(colaboradorId)
      .then((v) => {
        if (alive) setVeiculos(Array.isArray(v) ? v : []);
      })
      .catch((err) => {
        // Aviso é acessório — se falhar (permissão/rede), simplesmente não aparece.
        if (alive && err instanceof ApiError) setVeiculos([]);
      });
    return () => {
      alive = false;
    };
  }, [colaboradorId]);

  if (colaboradorId == null || dispensado || veiculos.length === 0) return null;

  return (
    <div className="manut-aviso-stack">
      <div className="manut-aviso">
        <span className="manut-aviso-icon" aria-hidden="true">🔧</span>
        <span className="manut-aviso-texto">
          <strong>Manutenção de veículo</strong> —{" "}
          {veiculos.length === 1
            ? "há 1 veículo"
            : `há ${veiculos.length} veículos`}{" "}
          sob sua responsabilidade precisando de atenção:{" "}
          {veiculos.map((v, i) => (
            <span key={v.id}>
              {i > 0 ? ", " : ""}
              <strong>{v.placa || v.modelo || `#${v.id}`}</strong> ({v.situacao_manutencao})
            </span>
          ))}
        </span>
        <button
          type="button"
          className="manut-aviso-fechar"
          onClick={() => setDispensado(true)}
          title="Dispensar aviso"
          aria-label="Dispensar aviso"
        >
          <IconClose size={14} />
        </button>
      </div>
    </div>
  );
}
